<template>
    <div class="x-detail">
        <el-popover
            popper-class="x-detail-popper"
            placement="bottom"
            width="auto"
            trigger="click"
            :content="modelValue"
        >
            <template #reference>
                <div class="content">{{ modelValue }}</div>
            </template>
        </el-popover>
    </div>
</template>
<script setup>
import { defineProps, ref, watch } from "vue";

const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    modelValue: { default: null },
    data: { default: null },
    field: { default: null }
});
const content = ref("");
// const div = document.createElement("div");
// div.innerHTML = props.modelValue;
// content.value = div.innerText;

watch(
    () => props.modelValue,
    () => {
        const content = ref("");
        const div = document.createElement("div");
        div.innerHTML = props.modelValue;
        content.value = div.innerText;
        console.log(props.modelValue, div.innerText);
    }
);
</script>
<style scoped>
.x-detail >>> .content {
    text-overflow: ellipsis;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    cursor: pointer;
}
</style>
<style>
.x-detail-popper {
    max-width: 400px !important;
}
</style>
